import React, { useState, useEffect } from 'react';
import API from '../utils/api';
import { format, addDays, startOfWeek } from 'date-fns';
import { es } from 'date-fns/locale';

const DIAS = ['lunes','martes','miercoles','jueves','viernes','sabado','domingo'];
const DIAS_LABEL = ['Lun','Mar','Mié','Jue','Vie','Sáb','Dom'];

export default function Horario() {
  const [datos, setDatos] = useState(null);
  const [semanaIdx, setSemanaIdx] = useState(0);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    API.get('/app/mi-horario')
      .then(r => { setDatos(r.data); setCargando(false); })
      .catch(() => setCargando(false));
  }, []);

  if (cargando) return <div style={{ textAlign:'center', padding:40, color:'#9CA3AF' }}>Cargando horario...</div>;

  if (!datos?.empleado) return (
    <div style={{ textAlign:'center', padding:'60px 20px', color:'#9CA3AF' }}>
      <div style={{ fontSize:48, marginBottom:12 }}>📅</div>
      <div style={{ fontWeight:600 }}>Sin horario asignado</div>
      <div style={{ fontSize:13, marginTop:4 }}>Tu administrador aún no ha publicado tu horario</div>
    </div>
  );

  const semanas = datos.semanas || [];
  const semana = semanas[semanaIdx];

  const turnosDeSemana = semana
    ? datos.turnos.filter(t => t.semana_inicio === semana.semana_inicio)
    : [];

  const turnosPorDia = (dia) => turnosDeSemana.filter(t => t.dia === dia);

  const horas = (inicio, fin) => {
    if (!inicio || !fin) return '';
    return `${inicio.slice(0,5)} – ${fin.slice(0,5)}`;
  };

  const inicioSemana = semana ? new Date(semana.semana_inicio + 'T12:00') : null;

  const totalHoras = turnosDeSemana.reduce((s, t) => {
    if (!t.hora_inicio || !t.hora_fin) return s;
    const [h1, m1] = t.hora_inicio.split(':').map(Number);
    const [h2, m2] = t.hora_fin.split(':').map(Number);
    return s + (h2*60+m2 - h1*60-m1) / 60;
  }, 0);

  return (
    <div>
      <h1 style={{ margin:'0 0 16px', fontSize:20, fontWeight:800, color:'#111827' }}>📅 Mi horario</h1>

      {/* Selector de semana */}
      {semanas.length > 1 && (
        <div style={{ display:'flex', gap:8, marginBottom:16, overflowX:'auto', paddingBottom:4 }}>
          {semanas.map((s, i) => {
            const fecha = new Date(s.semana_inicio + 'T12:00');
            return (
              <button key={i} onClick={() => setSemanaIdx(i)}
                style={{ padding:'6px 14px', borderRadius:20, border:`2px solid ${semanaIdx===i?'#1a1a2e':'#E5E7EB'}`, background:semanaIdx===i?'#1a1a2e':'white', color:semanaIdx===i?'white':'#374151', cursor:'pointer', fontSize:12, fontWeight:600, whiteSpace:'nowrap', flexShrink:0 }}>
                {format(fecha, "d 'de' MMM", { locale: es })}
              </button>
            );
          })}
        </div>
      )}

      {!semana ? (
        <div style={{ textAlign:'center', padding:'40px 20px', color:'#9CA3AF' }}>
          <div style={{ fontSize:36, marginBottom:8 }}>📭</div>
          <div>Sin programación disponible</div>
        </div>
      ) : (
        <>
          {/* Resumen semana */}
          <div style={{ background:'#1a1a2e', borderRadius:14, padding:'14px 18px', marginBottom:16, display:'flex', justifyContent:'space-between', alignItems:'center' }}>
            <div>
              <div style={{ color:'rgba(255,255,255,0.6)', fontSize:12 }}>Semana del</div>
              <div style={{ color:'white', fontWeight:700, fontSize:15, marginTop:2 }}>
                {inicioSemana && format(inicioSemana, "d 'de' MMMM", { locale: es })}
              </div>
            </div>
            <div style={{ textAlign:'right' }}>
              <div style={{ color:'rgba(255,255,255,0.6)', fontSize:12 }}>Total horas</div>
              <div style={{ color:'#6EE7B7', fontWeight:800, fontSize:18 }}>{totalHoras.toFixed(1)}h</div>
            </div>
          </div>

          {/* Días */}
          <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
            {DIAS.map((dia, i) => {
              const turnos = turnosPorDia(dia);
              const fechaDia = inicioSemana ? addDays(inicioSemana, i) : null;
              const esHoy = fechaDia && format(fechaDia, 'yyyy-MM-dd') === format(new Date(), 'yyyy-MM-dd');
              return (
                <div key={dia} style={{ background:'white', borderRadius:12, padding:'12px 14px', boxShadow:'0 1px 3px rgba(0,0,0,0.07)', borderLeft:`3px solid ${esHoy?'#059669':turnos.length?'#2563EB':'#E5E7EB'}` }}>
                  <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                    <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                      <span style={{ fontWeight:700, fontSize:14, color: esHoy?'#059669':'#111827' }}>
                        {DIAS_LABEL[i]}
                        {esHoy && <span style={{ marginLeft:6, fontSize:11, background:'#D1FAE5', color:'#065F46', padding:'1px 6px', borderRadius:6 }}>Hoy</span>}
                      </span>
                      {fechaDia && <span style={{ fontSize:12, color:'#9CA3AF' }}>{format(fechaDia, 'd MMM', { locale: es })}</span>}
                    </div>
                    {turnos.length === 0 && <span style={{ fontSize:12, color:'#9CA3AF' }}>Libre</span>}
                  </div>
                  {turnos.length > 0 && (
                    <div style={{ marginTop:8, display:'flex', flexDirection:'column', gap:4 }}>
                      {turnos.map((t, j) => (
                        <div key={j} style={{ fontSize:13, color:'#374151', background:'#F3F4F6', borderRadius:8, padding:'6px 10px' }}>
                          <span style={{ fontWeight:600 }}>T{t.turno_num}</span>
                          <span style={{ marginLeft:8 }}>{horas(t.hora_inicio, t.hora_fin)}</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
}
